export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["accepted"] = "accepted";
    ApprovalStatus["rejected"] = "rejected";
    ApprovalStatus["pending"] = "pending";
})(ApprovalStatus || (ApprovalStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwcm92YWxTdGF0dXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYXBwcm92YWwvQXBwcm92YWxTdGF0dXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksY0FJWDtBQUpELFdBQVksY0FBYztJQUN4Qix1Q0FBcUIsQ0FBQTtJQUNyQix1Q0FBcUIsQ0FBQTtJQUNyQixxQ0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBSlcsY0FBYyxLQUFkLGNBQWMsUUFJekIifQ==